var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOptionSelected = function SvgOptionSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 9
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.592.508a.833.833 0 0 0-1.184 0L4.2 6.725 1.592 4.108A.852.852 0 1 0 .408 5.333l3.2 3.2a.834.834 0 0 0 1.184 0l6.8-6.8a.834.834 0 0 0 0-1.225Z"
  })));
};
export default SvgOptionSelected;